import React from 'react';
import { Alert } from 'react-bootstrap';

const plural = (count, singular, pluralForm) =>
    count === 1 ? singular : pluralForm;

/**
 * The positions budget in one sentence. "Awarded" is the places the program's
 * standing awards cover (the server's offeredPositions) and "funded" is the
 * places the budget pays for (allocatedPositions); the difference is what is
 * left, or what is over. The warning shows only when awards exceed funding.
 */
export function budgetSentence({ awarded, funded, unit, unitPlural }) {
    const head = `${awarded} ${plural(awarded, unit, unitPlural)} awarded, ${funded} funded`;
    if (awarded > funded) return `${head}: ${awarded - funded} over budget`;
    if (awarded === 0 && funded === 0) return head;
    if (awarded === funded) return `${head}: every funded place is awarded`;
    const left = funded - awarded;
    return `${head}: ${left} ${plural(left, 'place', 'places')} left to award`;
}

function BudgetLine({ budget, unit, unitPlural }) {
    if (!budget) return null;
    const awarded = budget.offeredPositions ?? 0;
    const funded = budget.budget?.allocatedPositions ?? 0;
    const accepted = budget.acceptedPositions ?? 0;
    const payRate = budget.budget?.payRate > 0;
    const over = awarded > funded;
    const sentence = budgetSentence({ awarded, funded, unit, unitPlural });
    // Active assignments, the same count as the header's active figure and
    // the Active tab; not Hiring progress's accepted places, which count only
    // awarded sections
    const detail = `${accepted} ${plural(accepted, unit, unitPlural)} active this term${
        payRate
            ? `. $${(budget.committedAmount ?? 0).toLocaleString()} committed of $${(budget.budget.allocatedAmount ?? 0).toLocaleString()}`
            : ''
    }`;

    return (
        <Alert
            variant={over ? 'warning' : 'light'}
            className="border py-2 px-3 mb-3 coordinator-budget-line"
        >
            <strong>{sentence}</strong>
            <span className="text-body-secondary"> ({detail})</span>
        </Alert>
    );
}

export default BudgetLine;
